<script lang="ts">
	import label from '$lib/assets/images/label.png';
	import arrowBack from '$lib/assets/images/arrow_black.svg';
	import arrowWhite from '$lib/assets/images/arrow_white.svg';
	import { formOpen, masters, selectedMaster } from '$lib/index.svelte';
	import thumbstack from '$lib/assets/images/trombone.png';

	let currentMasterIndex = $state(0);

	function nextMaster() {
		if (currentMasterIndex + 1 >= masters.length) {
			currentMasterIndex = 0;
		} else {
			currentMasterIndex = currentMasterIndex + 1;
		}
	}

	function prevMaster() {
		if (currentMasterIndex === 0) {
			currentMasterIndex = masters.length;
		}
		currentMasterIndex = currentMasterIndex - 1;
	}
	function chooseMaster() {
		selectedMaster.idx = currentMasterIndex;
		formOpen.status = true;
	}
</script>

<section id="masters" class="flex min-h-screen items-center justify-center">
	<div class="mx-25 my-30 flex h-full w-full flex-col items-center justify-center">
		<h2 class="text-center text-[2rem] uppercase">discover our masters</h2>
		<p class="mt-3 mb-10 max-w-140 text-center text-xl leading-[130%] tracking-percent">
			Meet our Maîtres Fromagers, each with a unique vision of cheese. Explore their profiles and
			choose your match.
		</p>

		<div class="mt-20 flex w-full items-center justify-between gap-10">
			<button
				onclick={prevMaster}
				class="hidden h-31.25 w-31.25 items-center justify-center rounded-full border-2 backdrop-blur-3xl md:flex"
				aria-label="previous master"
			>
				<img class="h-12.5 w-19.5 rotate-180" src={arrowWhite} alt="" />
			</button>

			<div class="w-140">
				{#each masters as master, i (master.firstName)}
					<div class={['bg-white p-5 text-black', { hidden: currentMasterIndex !== i }]}>
						<div class="relative mb-10.5">
							<div
								class="relative mx-auto h-47.5 w-41.25 -translate-y-5 rotate-5 md:h-77.5 md:w-68.75"
							>
								<img
									class="h-full w-full border-10 border-taupe-200 object-cover"
									src={master.image}
									alt="{master.firstName} {master.lastName}'s portrait"
								/>
								<img
									class="absolute top-0 right-5 h-29 translate-y-[-18%] rotate-7"
									src={thumbstack}
									alt=""
								/>
							</div>

							<img
								class="absolute bottom-0 left-1/2 w-28.75 translate-x-[-150%] -rotate-26 mix-blend-difference md:w-45"
								src={label}
								alt=""
							/>
						</div>
						<div class="flex flex-col items-center">
							<p class="mb-2 text-xl opacity-55">Maître Fromager</p>
							<h3 class="text-center text-[28px] font-semibold tracking-[-1px] uppercase">
								{master.firstName}
								{master.lastName}
							</h3>
							<div class="mt-8 flex w-full flex-col">
								<div class="border-t py-3">
									<h4 class="text-xs font-semibold uppercase">Signature expertise</h4>
									<p class="font-mono text-lg uppercase">{master.expert}</p>
								</div>
								<div class="border-t py-3">
									<h4 class="text-xs font-semibold uppercase">What drives them</h4>
									<p class="font-mono text-lg uppercase">{master.drive}</p>
								</div>
								<div class="border-t border-b py-3">
									<h4 class="text-xs font-semibold uppercase">Beyond cheese</h4>
									<p class="font-mono text-lg uppercase">{master.beyond}</p>
								</div>
								<button
									onclick={chooseMaster}
									class="my-8 flex items-center justify-between gap-2 rounded-sm bg-theme-brown p-5 font-bold text-black uppercase"
									>I choose {master.firstName} <img src={arrowBack} alt="" /></button
								>
							</div>
						</div>
					</div>
				{/each}
				<div class="mt-10 flex items-center gap-3">
					<button
						onclick={prevMaster}
						class="flex h-12.5 w-12.5 shrink-0 items-center justify-center rounded-full border backdrop-blur-3xl md:hidden"
						aria-label="previous master"
					>
						<img class="h-5 w-7.5 rotate-180" src={arrowWhite} alt="" />
					</button>
					<div class="relative mx-auto h-0.75 w-full rounded-full bg-white/30 md:w-67.5">
						<div
							style="left:{33.33 * currentMasterIndex}%"
							class="absolute top-0 h-0.75 w-1/3 rounded-full bg-white md:w-28.5"
						></div>
					</div>
					<button
						class="flex h-12.5 w-12.5 shrink-0 items-center justify-center rounded-full border backdrop-blur-3xl md:hidden"
						onclick={nextMaster}
						aria-label="next master"
					>
						<img class="h-5 w-7.5" src={arrowWhite} alt="" />
					</button>
				</div>
			</div>
			<button
				class="hidden h-31.25 w-31.25 items-center justify-center rounded-full border-2 backdrop-blur-3xl md:flex"
				onclick={nextMaster}
				aria-label="next master"
			>
				<img class="h-12.5 w-19.5" src={arrowWhite} alt="" />
			</button>
		</div>
	</div>
</section>
